import { useAsyncData, useNuxtApp } from 'nuxt/app';
import { useContentMenusStore } from '~~/common/stores/contentMenus';

/**
 * Loads a content menu (career, petrol, footer, …) into the contentMenus store
 * behind a shared useAsyncData key derived from the menu path. Any components
 * requesting the same menu on a single page — e.g. a page component and a
 * CMS-driven sidebar that is only conditionally rendered — dedupe into one
 * SSR-cached request instead of each fetching independently. The locale is part
 * of the key because menu content is locale-specific.
 */
export function useContentMenu (path: string) {
  const contentMenusStore = useContentMenusStore();
  const { $i18n } = useNuxtApp();
  return useAsyncData(`contentMenu@${$i18n.locale.value}@${path}`, () => contentMenusStore.initMenu(path).then(() => true));
}
